module.exports = __webpack_public_path__ + "05b2076987a562698a065545468340f7.pdf";